// extracted by css-extract-rspack-plugin
export default {"cls1":"SwpBulkFollowTakeover-cls1_04-","cls2":"SwpBulkFollowTakeover-cls2_LXK SwpBulkFollowTakeover-cls1_04-"};